enum ContractRequirementStatus {
  Danger = 'danger',
  Success = 'success',
}

const enum WeekDays {
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Sunday,
}

enum CalendarDisplayRange {
  ONE_DAY = 1,
  THREE_DAYS = 3,
  WEEK = 7,
}

enum BaseHue {
  green = 'green',
  orange = 'orange',
  purple = 'purple',
  blue = 'blue',
  pink = 'pink',
  gold = 'gold',
  silver = 'silver',
  teal = 'teal',
  yellow = 'yellow',
  cyan = 'cyan',
  indigo = 'indigo',
}

enum ShiftAssignStatus {
  default,
  offered,
  vtoAvailable,
  vtoAccepted = 4,
}

enum AllShiftItemType {
  schedule,
  shiftAvailable,
  headcount,
}

enum ContractStatus {
  current = 'Current',
  termination = 'Termination',
  resignationPending = 'ResignationPending',
  resignationApproved = 'ResignationApproved',
  suspension = 'Suspension',
  unknown = 'Unknown',
  expired = 'Expired',
}

enum ResTermType {
  suspension = 'Suspension',
  termination = 'Termination',
  resignation = 'Resignation',
  reinstatement = 'Reinstatement',
}

enum ResTermTypeFromPayload {
  resignation = 0,
  suspension,
  termination,
  reinstatement,
}

enum EffectiveType {
  effectiveDate = '0',
  effectiveBillingPeriod = '1',
  immediately = '2',
}

enum UserType {
  unauthorized = 0,
  agent,
  client,
  admin = 4,
}

enum ClassesTabType {
  summary = -1,
  registered = -2,
  sessions = -3,
  removed = -4,
}

enum AuthStatus {
  newSession,
  loggedIn,
  loggedOut,
}

enum RequirementType {
  min = 'Minimum',
  max = 'Maximum',
  base = 'Base',
  peak = 'Peak',
}

enum ApplicantList {
  limit = 50,
  initialPage = 1,
  initialEntry = 0,
}

enum KnownErrors {
  ItemNotFound = 'Item not found',
}

enum ResourceTypeId {
  announcement,
  document,
  link,
  database,
}

export enum RestermReasonType {
  resignation, // available for SP
  termination_and_suspension, // available for SU
}

enum ResourceVisibility {
  unpublished,
  published,
  expired,
}

enum AnnouncementType {
  alert,
  regular,
}

enum CourseBuilder {
  maxReschedules = 10,
  maxTraining = 180,
  minValue = 0,
}

const enum PathParams {
  contractId = 'contractId',
  tab = 'tab',
  spId = 'serviceProviderId',
  spTab = 'spTab',
  spContractId = 'spContractId',
  weekId = 'weekid',
  days = 'days',
}

enum InterviewStatus {
  upcoming = 6,
  inReview = 8,
}

enum ApplicationStatus {
  None = 0,
  IncompleteApplication = 1,
  ApplicationSubmitted = 2,
  DeclinedApplication = 3,
  NewApplicantInReview = 4,
  InvitetoInterview = 5,
  InterviewScheduled = 6,
  InterviewInReview = 8,
  InviteToTraining = 10,
  RegisteredforTraining = 12,
  CompletedTraining = 13,
  FailedTraining = 14,
  PassedTraining = 18,
  RescheduleInterview = 22,
  RescheduleClass = 26,
}

enum ApplicationStep {
  Contract = 1,
  MobileNumber = 2,
  EducationAndLanguage = 3,
  WorkHistory = 4,
  VoiceInterview = 5,
  Acknowledgements = 6,
  Photo = 7,
  InternetTest = 8,
  ComputerTest = 9,
  Equipment = 10,
  Tax = 11,
  BackgroundCheck = 12,
}

const enum ResTermStatus {
  Resigned = 0,
  Ineligible = 1,
  Removed = 2,
}

const enum PaymentType {
  DEFER = 'defer',
  PAYPAL = 'paypal',
  REGISTER = 'register',
}

const enum ClassLedgerType {
  Paypal = 1,
  CourseCost = 2,
  Payshark = 3,
}

const enum TargetType {
  BLANK = '_blank',
  SELF = '_self',
  PARENT = '_parent',
  TOP = '_top',
}

const enum PasswordServiceType {
  manage = 'MANAGE_ENGINE',
  webmail = 'WEBMAIL',
  moodle = 'MOODLE',
}

const enum GigApplyType {
  GigApplyKey = 'gig_apply_id',
}

const enum AttendanceType {
  AttendanceSessionKey = 'attendanceSession',
}

const enum FraudGroupType {
  FraudGroupKey = 'fraudGroup',
}

const enum AttendanceStatus {
  SUCCESS = 'SUCCESS',
  ERROR_NOT_YOUR_CLASS = 'ERROR_NOT_YOUR_CLASS',
  ERROR_INVALID_LINK = 'ERROR_INVALID_LINK',
}

const enum StageTwoType {
  StageTwoKey = 'stage_two_id',
}

const enum SidebarSchedules {
  default,
  availability,
}

const enum WeekStartEnd {
  Start = 'start',
  End = 'end',
}

const enum Action {
  Unchanged = 0,
  New = 1,
  Removed = 2,
}

const enum GigPhase {
  Inactive = 0,
  Training = 1,
  Incubation = 2,
  Live = 3,
}

const enum InterviewStatusType {
  Available = 0,
  Scheduled = 1,
  Cancelled = 2,
  Completed = 3,
  Conflicted = 4,
}

const enum Attriton {
  Attrition = 'Attrition',
}

const enum Esign {
  Msa = 'MSA',
  Sow = 'SOW',
}

enum DaysRangeEnum {
  ZERO_TO_TWO_DAYS = 0,
  TWO_TO_FOUR_DAYS = 172800,
  MORE_THAN_FOUR_DAYS = 343600,
}

export enum GigPhases {
  Inactive = 0,
  Training = 1,
  Incubation = 2,
  Live = 3,
}

export enum SelectedTypeCategoryName {
  Incubation = 'Incubation',
  Live = 'Live',
  InactiveNew = 'Inactive - New',
  InactiveInterview = 'Inactive - Interview',
  InactiveTraining = 'Inactive - Training',
  Attrition = 'Attrition',
}

export enum ApplicantTabRefreshEnum {
  RefreshApplicantListOnly = 1,
  RefreshApplicantListAndCountAndSetFilter = 2,
}

export enum ClassAttendanceEnum {
  size = 5,
  mobileSize = 1,
  passed = 1,
  failed = 2,
  removed = 3,
  retry = 4,
}

enum SortTypeEnum {
  LastUpdated = 1,
  Created = 2,
  FirstName = 3,
  LastName = 4,
  InterviewDate = 5,
  AIScore = 6,
}

enum SortTypeValuesEnum {
  'Last Updated' = 1,
  'Created' = 2,
  'First Name' = 3,
  'Last Name' = 4,
  'Interview Date' = 5,
  'AI Score' = 6,
}

export enum ClassUserStatus {
  Registered = 0,
  Passed = 1,
  Failed = 2,
  Removed = 3,
  SUReschedule = 4,
  SPReschedule = 5,
}

export enum ClassStatus {
  Open = 1,
  Paused = 2,
  Completed = 3,
  Closed = 4,
  Cancelled = 5,
}

export enum ClassProposedStatus {
  Open = 1,
  Paused = 2,
  Completed = 3,
  Cancelled = 5,
  Upcoming = 6,
  Live = 7,
  Incomplete = 8,
}

export enum CountriesWithShortINTLCodePhoneNumber {
  Phillipines = 7,
  India = 8,
}

export enum CountriesWithNineDigitPhoneNumber {
  SouthAfrica = 9,
  Morocco = 11,
}

export enum CommunityType {
  Blog = 1,
  Faq = 2,
  Testimonial = 3,
}

export enum CommunityPublishStatus {
  Now = 1,
  Unpublished = 2,
  Future = 3,
}

export enum Countries {
  UnitedStates = 1,
  Canada = 2,
  Dominica = 3,
  Barbados = 4,
  Jamaica = 5,
  DominicanRepublic = 6,
  Philippines = 7,
  India = 8,
  SouthAfrica = 9,
  Mexico = 10,
  Morocco = 11,
  Columbia = 12,
}

export enum CommunityBlogCategory {
  Articles = 1,
  Guides = 2,
  Events = 3,
  NewMemberGuides = 4,
  SuccessStories = 5,
}

export enum CommunitySection {
  Main = 1,
  Featured = 2,
  Recommended = 3,
  Home = 4,
}

export enum CommunityBlogSortOptions {
  Trending = 1,
  Latest = 2,
  UpcomingEvents = 3,
  PastEvents = 4,
  MostViewed = 5,
}

export {
  Action,
  AllShiftItemType,
  AnnouncementType,
  ApplicationStatus,
  ApplicationStep,
  ResTermStatus,
  AuthStatus,
  CalendarDisplayRange,
  ContractRequirementStatus,
  ContractStatus,
  EffectiveType,
  InterviewStatus,
  KnownErrors,
  PasswordServiceType,
  PathParams,
  PaymentType,
  ClassLedgerType,
  RequirementType,
  ApplicantList,
  ResourceTypeId,
  ResourceVisibility,
  ResTermType,
  ResTermTypeFromPayload,
  BaseHue,
  ShiftAssignStatus,
  TargetType,
  UserType,
  ClassesTabType,
  WeekDays,
  WeekStartEnd,
  GigApplyType,
  AttendanceType,
  FraudGroupType,
  AttendanceStatus,
  SidebarSchedules,
  GigPhase,
  InterviewStatusType,
  Attriton,
  Esign,
  DaysRangeEnum,
  SortTypeEnum,
  SortTypeValuesEnum,
  CourseBuilder,
  StageTwoType,
};

export enum applicationEndTypeIdStatus {
  ServiceUserInitiated = 1,
  ServiceProviderInitiated = 2,
  SystemTriggered = 3,
}

export enum CommunicationType {
  Phone = 1,
  Sms = 2,
  SupportMeeting = 3,
}

export enum applicationPhaseIdStatus {
  Incomplete = 1,
  InProgress = 2,
  Complete = 3,
}

export enum applicationEndReasonTypeId {
  ApplicantNotInterested = 1,
  Ineligible = 2,
  PoorOrIncompleteVoiceScript = 3,
  BackgroundNoise = 4,
  NotAGoodFit = 5,
  ConflictofInterest = 6,
  SUInitiatedOtherReasons = 7,
  NoLongerInterested = 8,
  PayTooLow = 9,
  SchedulingConflict = 10,
  NotLookingFor = 11,
  SPInitiatedOtherReasons = 12,
  Expired = 13,
  InvalidAddress = 14,
  FradulentInformation = 15,
  ApplicationProcessUnclear = 16,
  TechnicalRequirements = 17,
  CampaignClosed = 18,
  RemovedFromTraining = 19,
}

export enum ApplicationLockTypeIdStatus {
  For30Days = 1,
  ToThisGig = 2,
  ForThisServiceUser = 3,
}

export enum ApplicationDeclinedType {
  NEW = 1,
  INTERVIEW = 2,
  TRAINING = 3,
}

export enum FraudCheckType {
  DuplicateIPAddress = 1,
  DuplicatePCSignature = 2,
}

export enum crousalHeader {
  size = 5,
}

export enum AdSourceId {
  CopyTextEmail = 7,
  Facebook = 8,
  X = 9,
}

export enum EsignDocStatus {
  Expired = 0,
  Unsigned = 1,
  Signed = 2,
}

export enum VocabRatioType {
  NewApplicants = 1,
  InvitedToInterview = 2,
  InvitedToTraining = 3,
  RegisteredForTraining = 4,
  Day1Attendance = 5,
  PassedLive40Hours = 6,
}

export enum VocabRatioProfile {
  New = 1,
  Moderate = 2,
  Veteran = 3,
  Custom = 0,
}

export enum CLIENT {
  TELEPERFORMANCE_TURBO_TAX = 297,
}

export enum BackgroundCheckStatus {
  None = 0,
  Pending = 1,
  Pass = 2,
  Fail = 3,
  Pending_Sent = 4,
  Pending_Partial = 5,
  Pending_Analyzing = 6,
  Pending_InProgress = 7,
}
